import api from "@resources/js/http/api";


export const sendContacts = async (options) => {
    try {
        const response =  await api.post('/contact/', options);
        return response?.data?.success;
    }catch (e) {
        return false;
    }
}
